import { render, staticRenderFns } from "./Accounts.vue?vue&type=template&id=5fb8e3e4&scoped=true"
import script from "./Accounts.vue?vue&type=script&lang=js"
export * from "./Accounts.vue?vue&type=script&lang=js"
import style0 from "./Accounts.vue?vue&type=style&index=0&id=5fb8e3e4&prod&scoped=true&lang=css"
import style1 from "./Accounts.vue?vue&type=style&index=1&id=5fb8e3e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb8e3e4",
  null
  
)

export default component.exports